import { Toaster } from '@ember/ui'
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { router } from './router'
import './index.css'

// Same defaults idea as rei-app: data fetched in the last 30s is served from
// cache when a page re-mounts (navigating back to a list, reopening a detail)
// instead of refetching on every mount. Any successful mutation marks every
// cached query stale, so an edit on one page never leaves another page showing
// pre-edit data; only queries on screen refetch right away.
const queryClient: QueryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: () => {
      void queryClient.invalidateQueries()
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  </React.StrictMode>,
)
